// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6e6d24fa","96":"614e86c3","604":"dfa87dba"}[chunkId] + ".chunk.js";
};